import React, { useEffect, useState } from "react";
import { SITE } from "../config/siteConfig";

// Bandeau cookies + Consent Mode v2 (le consentement par défaut « denied » est posé dans public/index.html).
function grantedConsent() {
  return {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
  };
}

function deniedConsent() {
  return {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  };
}

function loadGoogleTag() {
  if (!SITE.googleTagId || document.getElementById("gtag-js")) return;
  const s = document.createElement("script");
  s.id = "gtag-js";
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + SITE.googleTagId;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  window.gtag("config", SITE.googleTagId);
}

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let saved = null;
    try {
      saved = localStorage.getItem("consentMode");
    } catch {
      saved = null;
    }
    if (!saved) {
      setVisible(true);
    } else if (saved.indexOf("granted") !== -1) {
      loadGoogleTag();
    }
  }, []);

  function choose(accept) {
    const consent = accept ? grantedConsent() : deniedConsent();
    try {
      localStorage.setItem("consentMode", JSON.stringify(consent));
    } catch {
      // stockage indisponible : le choix vaut pour cette page
    }
    if (window.gtag) window.gtag("consent", "update", consent);
    if (accept) loadGoogleTag();
    setVisible(false);
  }

  if (!visible) return null;
  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Gestion des cookies">
      <p>
        Nous utilisons des cookies pour mesurer l'audience et l'origine des appels. Vous pouvez accepter ou refuser
        les cookies non essentiels. <a href="/cookies">Politique de cookies</a> ·{" "}
        <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">
          Règles de confidentialité de Google
        </a>
      </p>
      <div className="cookie-actions">
        <button type="button" className="cookie-refuse" onClick={() => choose(false)}>
          Refuser
        </button>
        <button type="button" className="cookie-accept" onClick={() => choose(true)}>
          Accepter
        </button>
      </div>
    </div>
  );
}
